import { render, staticRenderFns } from "./WholesalerDetail.vue?vue&type=template&id=206add04&"
import script from "./WholesalerDetail.vue?vue&type=script&lang=js&"
export * from "./WholesalerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports